<template>
    <card>
        <h2>Call statistics</h2>
        <ul>
            <li>All time: {{ statistics.all_time }}</li>
            <li>Last 30 days: {{ statistics.last_30_days }}</li>
            <li>Last 7 days: {{ statistics.last_7_days }}</li>
        </ul>
    </card>
</template>

<script>
    import axios from "axios";

    export default {
        name: "SchoolCallStatistics",
        props: {
            school_id: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                loading: false,
                statistics: {},
            }
        },
        mounted() {
            this.loadStatistics();
        },
        methods: {
            loadStatistics() {
                this.loading = true;
                axios({
                    url: this.baseAPIURL + 'school/' + this.school_id + '/calls', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.statistics = resp.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>
